import { __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { pagePropTypes, pageDefaultProps } from './Sidebar.types.js';
import { Layout } from './Layout.component.js';
import styles from './Sidebar.module.scss.js';

var Page = function (_a) {
    var slideTo = _a.slideTo, onTransitionEnd = _a.onTransitionEnd, className = _a.className, restProps = __rest(_a, ["slideTo", "onTransitionEnd", "className"]);
    var pageClass = clsx(className, styles.Page, styles["Page___".concat(slideTo)]);
    var handleOnTransitionEnd = function (e) {
        if (onTransitionEnd && e.propertyName === 'transform') {
            onTransitionEnd(slideTo);
        }
    };
    return (React__default.createElement(Layout, __assign({ handleOnTransitionEnd: handleOnTransitionEnd, className: pageClass, headerClassName: styles.Page_header, bodyClassName: styles.Page_body, footerClassName: styles.Page_footer }, restProps)));
};
Page.propTypes = pagePropTypes;
Page.defaultProps = pageDefaultProps;
Page.displayName = 'Sidebar.Page';

export { Page, Page as default };
